import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SnackBarAlertsService } from 'src/app/core/services/snackbar-alerts.service';

@Component({
  selector: 'app-school',
  template: `
    <app-header></app-header>
    <app-school-card [selectedSchoolId]="selectedSchoolId" [open]="true"></app-school-card>
  `
})
export class SchoolsComponent implements OnInit {

  selectedSchoolId: string;
  selectedProgram: string;
  schoolId: string;

  constructor(private route: ActivatedRoute, private alerts: SnackBarAlertsService) {}

  ngOnInit() {
    this.selectedSchoolId = this.route.snapshot.paramMap.get('selectedSchoolId');

    if (!this.selectedSchoolId) {
      this.alerts.show(`Found no schools with school id ${this.selectedSchoolId}`);
      return;
    } else if (this.selectedSchoolId) {
      this.schoolId = this.selectedSchoolId;
    }
  }

}
